import React from "react";
import { RefreshCw } from "lucide-react";

// lazy 청크 로드 실패(네트워크 불안정/배포 직후 옛 청크 만료 등) 대비 에러 바운더리.
// 흰 화면 대신 "다시 시도" 안내. 재시도는 새 청크를 받기 위해 전체 reload.
export default class LazyBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[LazyBoundary] chunk/render error:", error?.message);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F0F3F5] dark:bg-[#13161c] flex items-center justify-center px-6" data-testid="lazy-error">
          <div className="text-center max-w-xs">
            <div className="w-14 h-14 rounded-2xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm mx-auto flex items-center justify-center mb-4">
              <RefreshCw className="w-6 h-6 text-[#2563EB]" />
            </div>
            <p className="font-bold text-gray-900 dark:text-gray-100">화면을 불러오지 못했어요</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">네트워크 상태를 확인하고 다시 시도해주세요.</p>
            <button
              data-testid="lazy-retry-btn"
              onClick={() => window.location.reload()}
              className="mt-5 inline-flex items-center gap-2 bg-[#2563EB] text-white font-bold text-sm rounded-xl px-5 py-2.5"
            >
              <RefreshCw className="w-4 h-4" /> 다시 시도
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
